import type { IndeedConversation } from '../utils/findIndeedConversationInHistory';

import { getConversationsIdBasedOnJobSeeker } from 'services/browser-extension/indeed/getConversation';
import { getJobSeekerByMongoOrIndeed } from 'services/browser-extension/indeed/getJobSeeker';
import { useIndeedConfig } from 'shared/legacy/hooks/useBrowserExtension/indeed/useIndeedConfig';
import { useCurrentUserQuery } from 'shared/legacy/hooks/useCurrentUserQuery';

export const useDiscoverIndeedConversation = () => {
  const indeedConfig = useIndeedConfig();
  const { data: currentUser } = useCurrentUserQuery();

  return async ({
    candidateId,
    candidateName,
  }: {
    candidateId: string;
    candidateName: string;
  }): Promise<IndeedConversation | null> => {
    if (!currentUser || !indeedConfig.isLoggedIn) return null;

    const jobSeekerKey = await getJobSeekerByMongoOrIndeed({
      candidateId,
      candidateName,
      indeedConfig,
      tenantId: currentUser.tenant.id,
      userEmail: currentUser.email,
    });

    if (!jobSeekerKey) return null;

    const conversationsId = await getConversationsIdBasedOnJobSeeker({
      indeedConfig,
      jobSeekerKey,
      tenantId: currentUser.tenant.id,
      candidateId,
    });

    const conversationId = conversationsId[conversationsId.length - 1];

    if (!conversationId) return null;

    return { conversationId, jobSeekerKey };
  };
};
